export default __webpack_public_path__ + "13271c568a0371f66064067c8e779e73.png";